import { Controller } from "@hotwired/stimulus";
export default class extends Controller {
  static targets = ["documents", "name"];

  toggleDocuments() {
    this.documentsTarget.classList.toggle("d-none");
    this.nameTarget.classList.toggle("bold-blue");
  }
}
